import {Component, Input} from '@angular/core';
import {EventResponse, EventSponsorResponse, SponsorResponse} from '../../../../../../../../@shared/models/response.module';
import {EventsService} from '../../../../../../../../@shared/services/events-service';
import {_AQH_EVE_16, _AQH_EVE_18, _AQH_EVE_21} from '../../../../../../../../@shared/models/input.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddSponsor} from './components/add-sponsor/add-sponsor';
import {EditSponsor} from './components/edit-sponsor/edit-sponsor';
import {DeleteModal} from '../../../../../../../../@shared/components/delete-modal/delete-modal';

@Component({
  selector: 'app-manage-event-sponsor',
  standalone: false,
  templateUrl: './manage-event-sponsor.html',
  styleUrl: './manage-event-sponsor.css'
})
export class ManageEventSponsor {
  @Input() event: EventResponse
  sponsors: SponsorResponse[] = []
  eventSponsors: EventSponsorResponse[] = []
  loading: boolean = false;

  constructor(private eventsService: EventsService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.getSponsors()
  }

  getSponsors() {
    this.loading = true;
    let payload: _AQH_EVE_21 = {
      event_id: this.event.event_id
    }
    this.eventsService.getEventSponsors(payload).subscribe({
      next: (res: EventSponsorResponse[]) => {
        this.eventSponsors = res
        this.sponsors = res.map((es: EventSponsorResponse) => es.sponsor).filter((s: SponsorResponse | null | undefined) => s !== null && s !== undefined) as SponsorResponse[]
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.sponsors = []
        this.eventSponsors = []
      }
    })
  }

  openModal() {
    let modalRef = this.modalService.open(AddSponsor, { size: 'lg', centered: true });
    modalRef.componentInstance.event = this.event;
    modalRef.result.then((result: SponsorResponse) => {
      if (result && result.sponsor_id) {
        // Add the newly created sponsor to this event
        let addToEventPayload: _AQH_EVE_16 = {
          event_id: this.event.event_id,
          sponsor_id: result.sponsor_id
        }
        this.eventsService.addSponsorToEvent(addToEventPayload).subscribe(() => {
          console.log('Sponsor added to event');
          this.getSponsors();
        });
      }
    }, () => {});
  }

  openEditModal(sponsor: SponsorResponse) {
    let modalRef = this.modalService.open(EditSponsor, { size: 'lg', centered: true });
    modalRef.componentInstance.sponsor = sponsor;
    modalRef.result.then((result) => {
      if (result) {
        this.getSponsors();
      }
    }, () => {});
  }

  deleteSponsor(sponsor: SponsorResponse) {
    let modalRef = this.modalService.open(DeleteModal, { centered: true });
    modalRef.componentInstance.description = 'Are you sure you want to remove this sponsor from the event? This action cannot be undone.';
    modalRef.result.then((result) => {
      if (result) {
        // Find the entry_id for this sponsor
        const eventSponsor = this.eventSponsors.find(es => es.sponsor_id === sponsor.sponsor_id);
        if (eventSponsor) {
          let params: _AQH_EVE_18 = {
            entry_id: eventSponsor.entry_id
          }
          this.eventsService.removeSponsorFromEvent(params).subscribe(() => {
            this.getSponsors();
          });
        }
      }
    }, () => {})
  }
}
